import { GET_LAPORAN_TAHUNAN, SET_LOADING_LAPORAN_TAHUNAN, SET_PAGINATION_LAPORAN_TAHUNAN } from '../constant';

const initialState = {
  laporanTahunan: [],
  laporanTahunanPagination: 0,
  loadingLaporanTahunan: false,
  totalLaporanTahunan: 0,
};

const laporanTahunanReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_LAPORAN_TAHUNAN: {
      return {
        ...state,
        loadingLaporanTahunan: action?.payload,
      };
    }
    case SET_PAGINATION_LAPORAN_TAHUNAN: {
      return {
        ...state,
        laporanTahunanPagination: action?.payload,
      };
    }
    case GET_LAPORAN_TAHUNAN: {
      return {
        ...state,
        laporanTahunan: action?.payload?.data || [],
        totalLaporanTahunan: action?.payload?.total,
        loadingLaporanTahunan: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default laporanTahunanReducer;
